import React, { useState } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import {
  Wrapper,
  PersonWrapper,
  ImageWrapper,
  Image,
  TextWrapper,
  NameWrapper,
  Name,
  NameLink,
  DateWrapper,
  Type,
  TypeWrapper,
  IconWrapper,
  InfoIconEditor,
  Tooltip,
  TooltipTitle,
  Title,
  InfoIconReviewer,
  DesktopWrapper,
  MobileWrapper,
  NameToggle,
  TooltipName,
  TooltipReadMore,
  TooltipDesc,
  Background,
  ReviewerWrapper,
} from "./styles"

const Editor = ({
  partner,
  sponsor,
  author,
  reviewer,
  lastModifiedFormatted,
  publishDateFormatted,
  imagesGatsby,
}) => {
  const [tooltipActive, setTooltipActive] = useState(false)
  const [tooltipInputData, setTooltipInputData] = useState({})
  const toggleTooltip = (input) => {
    setTooltipActive(!tooltipActive)
    setTooltipInputData(input)
  }

  const imageGatsbyAuthor = imagesGatsby?.find(({ type }) => type === "author")
  const imageGatsbyReviewer = imagesGatsby?.find(({ type }) => type === "reviewer")

  const renderImage = (entity, imageGatsby) => (
    <ImageWrapper to={`/wc/${entity.url}`}>
      {imageGatsby ? (
        <GatsbyImage
          image={getImage(imageGatsby.localImage)}
          alt={entity.name}
          title={entity.name}
          loading="eager"
          placeholder="none"
          style={{
            width: "5.1rem",
            height: "5.1rem",
            borderRadius: "50%",
            zIndex: "1",
            overflow: "hidden",
          }}
        />
      ) : (
        <Image
          fetchpriority="high"
          baseUrl={entity.image}
          images={[
            {
              transforms: "c_fill,g_auto,w_50,h_50,q_auto,f_auto,fl_lossy",
            },
          ]}
          alt={entity.name}
        />
      )}
    </ImageWrapper>
  )

  const displayDate = lastModifiedFormatted || publishDateFormatted

  return (
    <>
      <MobileWrapper>
        <Wrapper>
          {/* Author section */}
          {(Boolean(author) || Boolean(reviewer)) && (
            <PersonWrapper>
              {Boolean(author) &&
                !(partner || sponsor) &&
                author.image &&
                renderImage(author, imageGatsbyAuthor)}
              {Boolean(reviewer) &&
                !author &&
                (reviewer.type === "expert" || reviewer.type === "medical") &&
                reviewer.image &&
                renderImage(reviewer, imageGatsbyReviewer)}
              <TextWrapper>
                {Boolean(author) && (
                  <TypeWrapper>
                    <Type>Author: </Type>
                    <NameWrapper>
                      <NameToggle onClick={() => toggleTooltip(author)}>{author.name}</NameToggle>
                    </NameWrapper>
                  </TypeWrapper>
                )}
                {Boolean(reviewer) && (
                  <ReviewerWrapper>
                    <Type>
                      {reviewer.type === "medical" && " Medical reviewer: "}
                      {reviewer.type === "expert" && " Expert reviewer: "}
                    </Type>
                    <NameWrapper>
                      <NameToggle onClick={() => toggleTooltip(reviewer)}>
                        {reviewer.name}
                      </NameToggle>
                    </NameWrapper>
                  </ReviewerWrapper>
                )}
                <Background tooltipActive={tooltipActive} onClick={() => toggleTooltip({})} />
                <Tooltip tooltipActive={tooltipActive}>
                  <TooltipName>{tooltipInputData.name}</TooltipName>
                  <TooltipTitle>{tooltipInputData.title}</TooltipTitle>
                  <TooltipDesc dangerouslySetInnerHTML={{ __html: tooltipInputData.credentials }} />
                  {tooltipInputData.url && (
                    <TooltipReadMore href={`/wc/${tooltipInputData.url}`}>
                      Read More
                    </TooltipReadMore>
                  )}
                </Tooltip>
                {displayDate && <DateWrapper>{displayDate}</DateWrapper>}
              </TextWrapper>
            </PersonWrapper>
          )}
        </Wrapper>
      </MobileWrapper>
      <DesktopWrapper>
        <Wrapper>
          {/* Author section */}
          {Boolean(author) && (
            <PersonWrapper hasReviewer={Boolean(reviewer)}>
              {!(partner || sponsor) && author.image && renderImage(author, imageGatsbyAuthor)}
              <TextWrapper>
                {author.title?.toLowerCase()?.trim() !== "mbg contributor" && (
                  <Title>{author.title || "Written by"}</Title>
                )}
                <NameWrapper>
                  <Name>
                    <NameLink to={`/wc/${author.url}`} title={author.name}>
                      {author.title ? `By ${author.name}` : author.name}
                    </NameLink>
                    {author.credentials && (
                      <>
                        <IconWrapper>
                          <InfoIconEditor id="info-icon" height="19px" width="19px" />
                        </IconWrapper>
                        <Tooltip>
                          <TooltipTitle>{author.title}</TooltipTitle>
                          <div dangerouslySetInnerHTML={{ __html: author.credentials }} />
                        </Tooltip>
                      </>
                    )}
                  </Name>
                </NameWrapper>
              </TextWrapper>
            </PersonWrapper>
          )}
          {/* Medical / Expert Reviewers section */}
          {Boolean(reviewer) && (
            <PersonWrapper hasReviewer>
              {(reviewer.type === "expert" || reviewer.type === "medical") &&
                reviewer.image &&
                renderImage(reviewer, imageGatsbyReviewer)}
              <TextWrapper>
                <Title isReviewer>
                  {reviewer.type === "medical" && "Medical review by"}
                  {reviewer.type === "expert" && "Expert review by"}
                </Title>
                {(reviewer.type === "expert" || reviewer.type === "medical") && (
                  <NameWrapper>
                    <Name>
                      <NameLink to={`/wc/${reviewer.url}`} title={reviewer.name}>
                        {reviewer.name}
                      </NameLink>
                      {reviewer.credentials && (
                        <>
                          <IconWrapper>
                            <InfoIconReviewer id="info-icon" height="19px" width="19px" />
                          </IconWrapper>
                          <Tooltip>
                            <TooltipTitle>{reviewer.title}</TooltipTitle>
                            <div dangerouslySetInnerHTML={{ __html: reviewer.credentials }} />
                          </Tooltip>
                        </>
                      )}
                    </Name>
                  </NameWrapper>
                )}
              </TextWrapper>
            </PersonWrapper>
          )}
        </Wrapper>
      </DesktopWrapper>
    </>
  )
}

export default Editor
